import React from 'react'

import MemberInformationForm from './member_information_form.jsx'

let MemberInformationRouter = () => ( // this doesn't have any nested routes to worry about, so we punt
  <MemberInformationForm />
)

export default MemberInformationRouter
